import { IDiscountState } from 'redux/modules/DiscountEditor/discountEditorTypes';
import { createSlice } from '@reduxjs/toolkit';

const initialState: IDiscountState = {
  discountCountry: undefined,
  selectedCities: undefined,
  mainInfoData: undefined,
  aboutFormData: undefined,
  companyInfoData: undefined,
  warning: undefined,
};

export const discountEditorReducer = createSlice({
  name: 'discountEditor',
  initialState,
  reducers: {
    setDiscountCountry: (state, action) => {
      state.discountCountry = action.payload;
    },
    setSelectedCities: (state, action) => {
      state.selectedCities = action.payload;
    },
    resetDiscountEditor: () => {
      return { ...initialState };
    },
    restoreDiscountEditor: (state, action) => {
      return { ...action.payload };
    },
    resetSelectedCities: (state) => {
      state.selectedCities = [];
    },
    setMainInfoData: (state, action) => {
      state.mainInfoData = { ...state.mainInfoData, ...action.payload };
    },
    saveLogoImage: (state, action) => {
      state.mainInfoData = { ...state.mainInfoData, logoImage: action.payload };
    },
    resetLogoImage: (state) => {
      state.mainInfoData = { ...state.mainInfoData, logoImage: undefined };
    },
    setAboutFormData: (state, action) => {
      state.aboutFormData = { ...state.aboutFormData, ...action.payload };
    },
    setCompanyInfoData: (state, action) => {
      state.companyInfoData = { ...state.companyInfoData, ...action.payload };
    },
    setExistingDiscount: (state, action) => {
      state.warning = {
        ...state.warning,
        existingDiscount: action.payload,
      };
    },
    setExistingDiscountID: (state, action) => {
      state.warning = {
        ...state.warning,
        existingDiscountID: action.payload,
      };
    },
    resetExistingDiscountID: (state) => {
      state.warning = {
        ...state.warning,
        existingDiscountID: undefined,
      };
    },
    resetExistingDiscount: (state) => {
      state.warning = {
        ...state.warning,
        existingDiscount: undefined,
      };
    },
    setPotentialDuplicate: (state, action) => {
      state.warning = {
        ...state.warning,
        potentialDuplicate: action.payload,
      };
    },
    resetPotentialDuplicate: (state) => {
      state.warning = {
        ...state.warning,
        potentialDuplicate: undefined,
      };
    },
    resetDiscountAboutFormData: (state) => {
      state.aboutFormData = undefined;
    },
    resetWarning: (state) => {
      state.warning = undefined;
    },
    setDiscountEditIds: (state, action) => {
      state.editMode = { ...state.editMode, ...action.payload };
    },
    setTempImgUrl: (state, action) => {
      state.mainInfoData = {
        ...(state.mainInfoData ?? {}),
        tempImgUrl: action.payload,
      };
    },
    resetTempImgUrl: (state) => {
      state.mainInfoData = { ...(state.mainInfoData ?? {}), tempImgUrl: '' };
    },
  },
});

export const {
  setDiscountCountry,
  setSelectedCities,
  resetDiscountEditor,
  restoreDiscountEditor,
  resetSelectedCities,
  setMainInfoData,
  saveLogoImage,
  resetLogoImage,
  setAboutFormData,
  setCompanyInfoData,
  setExistingDiscount,
  setExistingDiscountID,
  resetExistingDiscountID,
  resetExistingDiscount,
  setPotentialDuplicate,
  resetPotentialDuplicate,
  resetDiscountAboutFormData,
  resetWarning,
  setDiscountEditIds,
  setTempImgUrl,
  resetTempImgUrl,
} = discountEditorReducer.actions;

export default discountEditorReducer.reducer;
